import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=c12c10b8&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=c12c10b8&prod&lang=sass&"
import style1 from "./Settings.vue?vue&type=style&index=1&id=c12c10b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports